import { render } from "./DemandesListPage.vue?vue&type=template&id=4ff94e18&ts=true"
import script from "./DemandesListPage.vue?vue&type=script&lang=ts"
export * from "./DemandesListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__